import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { Role } from './listRoles';

export interface CreateRoleParams {
  name: string;
  description?: string;
  permissions: string[];
}

export interface CreateRoleResponse {
  success: boolean;
  role: Role;
  permissions: string[];
}

const createRole: MutationFunction<
  CreateRoleResponse,
  CreateRoleParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<CreateRoleResponse>(`/shared/roles`, {
    method: 'POST',
    body: {
      name: args.name,
      description: args.description || '',
      permissions: args.permissions,
    },
  });

  if (response.data) return response.data;
  throw new Error('Failed to create role');
};

export default createRole;

const _mockData: CreateRoleResponse = {
  success: true,
  role: {
    id: 'mock-created-id',
    name: 'New Role',
    description: 'Newly created role',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
  },
  permissions: ['loan.view_assigned'],
};
